export default __webpack_public_path__ + "static/tango-8d9841892b2ec89e388f746d7fef7795.png";